var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CCardHeader',[_vm._v(" "+_vm._s(_vm.cases.length)+" Active files ")]),_c('br'),_c('horizontal-scroll',[_c('data-table',_vm._b({},'data-table',_vm.bindings,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }